export const defaultTemplateHeadersQuickCollect = [
  'name',
  'countryCode',
  'phoneNumber',
  'amount',
  'notes'
];

export const templateDummayDataQuickCollect = [
  'Sam',
  '91',
  'XXXXXXXXXX',
  '1000',
  'Tuition fees'
];

export const addQuickCollectMemberTableColumn = [
  {
    Header: 'Name',
    accessor: 'name',
    style: 'group-hover:underline !font-medium',
    width: '35%'
  },
  { Header: 'Phone Number', accessor: 'phoneNumber', width: '50%' },
  { Header: 'Actions', accessor: 'actions' }
];

export enum QuickCollectFormDataKeys {
  AMOUNT = 'amount',
  NOTES = 'notes',
  SEND_PAYMENT_LINKS = 'sendPaymentLinks'
}

export const quickCollectFormDefaultValues = {
  amount: '',
  notes: '',
  sendPaymentLinks: true // Default to true (send links)
};

export const createQuickCollectLinkErrorMessage =
  'Failed to create quick collect link';

export const MAX_QUICK_COLLECT_MEMBER_COUNT = 30;
